var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { settingsModel } from '../../../models/service/settings.model';
import { controlModel } from '../../../models/core/control.model';
import { deviceModel } from '../../../models/core/device.model';
import { composeSpinner } from '../../../hoc/composeSpinner';

import { DATEPICKER_FORMAT, REFRESH_TIMEOUT_2_SEC, REFRESH_TIMEOUT_60_SEC } from '../../../constants/data.constant';
import { getCurrentDate } from '../../../services/service/settings.selectors';
import { convertDateToFromToByType, calcDateByType } from '../../../services/core/cost/cost.helper';
import { isDeviceStatusOn } from '../../../services/core/control/control.helper';
import { GLOBAL_TYPES } from '../../../device/types/global.types';
import { setCostDate, setCostType } from '../../../actions/cost.actions';

let timerId = null;
let deviceEnergyTimerId = null;

class DeviceContainer extends Component {
    constructor(...args) {
        var _temp;

        return _temp = super(...args), this._getCurrentDate = () => {
            return this.props.costState.date || this.props.currentDate;
        }, this._refreshLoad = (pause = REFRESH_TIMEOUT_2_SEC) => {
            clearTimeout(timerId);
            timerId = setTimeout(this._loadFull, pause);
        }, this._refreshLoadDeviceEnergy = (pause = REFRESH_TIMEOUT_60_SEC) => {
            clearTimeout(deviceEnergyTimerId);
            deviceEnergyTimerId = setTimeout(this._loadDeviceEnergy, pause);
        }, this._loadDeviceEnergy = (date = null) => {
            this._refreshLoadDeviceEnergy();
            const deviceId = this.props.deviceData.deviceId;
            date = date || this._getCurrentDate();
            const { to, from } = convertDateToFromToByType(date, this.props.costState.type);

            if (!this.props.deviceData.energy || !this.props.deviceData.energy.isLoading) {
                this.props.handleGetDeviceEnergy({
                    deviceId,
                    to,
                    from,
                    costMode: this.props.settings.settings[GLOBAL_TYPES.COST_MODE]
                });
            }

            if (!this.props.deviceData.chart || !this.props.deviceData.chart.isLoading) {
                this.props.handleGetDeviceEnergyChartData({
                    deviceId,
                    to,
                    from,
                    type: this.props.costState.type
                });
            }
        }, this._loadFull = () => {
            this._refreshLoad();
            const deviceId = this.props.deviceData.deviceId;
            if (this.props.deviceData.status && this.props.deviceData.status.isLoading || this.props.deviceData.power && this.props.deviceData.power.isLoading) {
                return;
            }

            this.props.handleGetBatchData([{
                apiFunc: deviceModel.apiGetDeviceStatus,
                processFunc: deviceModel.processGetDeviceStatus,
                params: { deviceId },
                errorFunc: deviceModel.requestGetDeviceStatus
            }, !isDeviceStatusOn(this.props.deviceData) && {
                apiFunc: deviceModel.apiGetDevicePower,
                processFunc: deviceModel.processGetDevicePower,
                params: { deviceId },
                errorFunc: deviceModel.requestGetDevicePower
            }]);
        }, this.handleSetDeviceStatus = () => {
            if (this.props.deviceData.changeStatus && this.props.deviceData.changeStatus.isLoading || !this.props.deviceData.status || !this.props.deviceData.status.Ch) {
                return;
            }

            const deviceId = this.props.deviceData.deviceId;
            const newStatusValue = this.props.deviceData.status.Ch === 'Off' || this.props.deviceData.status.Ch.value === 'Off' ? 'On' : 'Off';

            this.props.handleSetDeviceStatus({ deviceId, newStatusValue });
        }, this.handleGetPrev = () => {
            const currentDate = this._getCurrentDate();
            const date = calcDateByType(currentDate, this.props.costState.type, -1);
            this.props.handleSetCostDate(date);
        }, this.handleGetNext = () => {
            const currentDate = this._getCurrentDate();
            const date = calcDateByType(currentDate, this.props.costState.type);
            this.props.handleSetCostDate(date);
        }, this.handleChartType = type => {
            this.props.handleSetCostType(type);
        }, this.handleDateChange = newDate => {
            const date = moment(newDate, DATEPICKER_FORMAT).toDate();
            date.setHours(0, 0, 0, 0);
            this.props.handleSetCostDate(date);
        }, _temp;
    }

    componentDidMount() {
        setTimeout(() => {
            this._loadFull();
            this._loadDeviceEnergy();
        }, 0);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.costState.date !== prevProps.costState.date) {
            this.startTime();
            this._loadDeviceEnergy(this.props.costState.date);
        }

        if (this.props.costState.type !== prevProps.costState.type) {
            const date = this.props.costState.date || this._getCurrentDate();
            const { to, from } = convertDateToFromToByType(date, this.props.costState.type);
            this.handleDateChange(from);
        }

        if (prevProps.deviceData.chart && prevProps.deviceData.energy) {
            if (prevProps.deviceData.chart.isLoading || prevProps.deviceData.energy.isLoading) {
                if (!this.props.deviceData.chart.isLoading && !this.props.deviceData.energy.isLoading) {
                    this.clearSpinner();
                }
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(timerId);
        timerId = null;
        clearTimeout(deviceEnergyTimerId);
        deviceEnergyTimerId = null;
    }

    render() {
        return null;
    }
}

export const DeviceContainerCore = composeSpinner(DeviceContainer);

export const mapStateToPropsCore = (state, props) => {
    const currentDate = getCurrentDate(state);
    // const deviceData = state.device[deviceModel.MODEL_NAME];
    const controlsData = state.control[controlModel.MODEL_NAME];

    const deviceId = props.routeParams ? props.routeParams.deviceId : props.route.routeParams.deviceId;

    const items = controlsData.items && controlsData.items.length ? controlsData.items.filter(i => i.deviceId === deviceId) : [deviceModel.create()];

    return {
        currentDate,
        deviceModel,
        deviceData: _extends({}, items[0]),
        controlsData,
        costState: state.costReducer,
        settings: state.settings[settingsModel.MODEL_NAME]
    };
};

export const mapDispatchToPropsCore = (apiGetDeviceEnergyChartData, apiGetDeviceEnergy, apiGetBatchData, apiSetDeviceStatus) => dispatch => {
    return {
        handleSetCostType: bindActionCreators(setCostType, dispatch),
        handleSetCostDate: bindActionCreators(setCostDate, dispatch),
        handleSetDeviceStatus: bindActionCreators(apiSetDeviceStatus, dispatch),
        handleGetBatchData: bindActionCreators(apiGetBatchData, dispatch),
        handleGetDeviceEnergy: bindActionCreators(apiGetDeviceEnergy, dispatch),
        handleGetDeviceEnergyChartData: bindActionCreators(apiGetDeviceEnergyChartData, dispatch),
        handleClearDeviceData: bindActionCreators(deviceModel.actionClear.bind(null, deviceModel), dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/core/Device.container.js